export default __webpack_public_path__ + "static/media/value1.073b9438.png";